import {
  LogoutSvgIcon,
  NotificationSvgIcon,
  PurchaseOrderSvgIcon,
  RFQSvgIcon,
  SettingsSvgIcon,
  SubmittedBidSvgIcon,
} from "@/assets/svg";
import { LOGO } from "@/assets/images";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import { ToggleSidebar } from "../ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";
import { useSelector } from "react-redux";
import { type RootState } from "@/redux/features/root-reducer";
import routesPath from "@/utils/routesPath";
import { Link, useLocation } from "react-router-dom";
import { clientLogout } from "@/utils/auth/logout";

const { DASHBOARD, NOTIFICATIONS, SUBMITTED_BIDS, PURCHASE_ORDER, SETTINGS } =
  routesPath;

export default function Topnav() {
  const isMobile = useIsMobile();
  const { user } = useSelector((state: RootState) => state.auth);

  const navLinks = [
    {
      name: "RFQs",
      url: DASHBOARD,
      icon: <RFQSvgIcon />,
      iconWhite: <RFQSvgIcon fill="white" />,
    },
    {
      name: "Submitted Bids",
      url: SUBMITTED_BIDS,
      icon: <SubmittedBidSvgIcon />,
      iconWhite: <SubmittedBidSvgIcon fill="white" />,
    },
    {
      name: "Purchase Order",
      url: PURCHASE_ORDER,
      icon: <PurchaseOrderSvgIcon />,
      iconWhite: <PurchaseOrderSvgIcon fill="white" />,
    },
    {
      name: "Notifications",
      url: NOTIFICATIONS,
      icon: <NotificationSvgIcon />,
      iconWhite: <NotificationSvgIcon fill="white" />,
    },
    {
      name: "Profile/Settings",
      url: "#",
      icon: <SettingsSvgIcon />,
      iconWhite: <SettingsSvgIcon fill="white" />,
      hidden: isMobile ? false : true,
    },
    {
      name: "Logout",
      url: "#",
      icon: <LogoutSvgIcon />,
      hidden: isMobile ? false : true,
    },
  ];

  const pathname = useLocation().pathname;

  return (
    <section className="p-4 bg-white border-b border-b-[#dededf] flex items-center justify-between lg:px-8 xl:px-12">
      <img
        src={LOGO}
        alt="logo"
        className="h-[30px] w-[129px] md:w-[130px] max-w-[280px] md:h-[32px] md:max-h-[43px]"
      />

      <div className="flex items-center gap-18">
        {navLinks.map((item) => {
          if (item.name === "Logout") {
            return (
              <button
                key={item.name}
                onClick={clientLogout}
                className={cn(
                  "hidden p-2 px-3 cursor-pointer transition-all duration-500 rounded-sm lg:flex items-center gap-1 hover:bg-primary group",
                  item.hidden && "lg:hidden"
                )}
              >
                <span className="group-hover:hidden">{item.icon}</span>
                <span className="hidden group-hover:inline">
                  {item.iconWhite}
                </span>
                <h4 className="text-[#131515] text-sm group-hover:text-white">
                  {item.name}
                </h4>
              </button>
            );
          }

          return (
            <Link
              to={item.url}
              key={item.name}
              className={cn(
                "hidden p-2 px-3 cursor-pointer transition-all duration-500 rounded-sm lg:flex items-center gap-1 hover:bg-primary group",
                item.hidden && "lg:hidden",
                pathname === item.url && "bg-primary text-white"
              )}
            >
              <span
                className={cn(
                  "group-hover:hidden",
                  pathname === item.url && "hidden"
                )}
              >
                {item.icon}
              </span>
              <span
                className={cn(
                  "hidden group-hover:inline",
                  pathname === item.url && "inline"
                )}
              >
                {item.iconWhite}
              </span>

              <h4
                className={cn(
                  "text-[#131515] text-sm group-hover:text-white",
                  pathname === item.url && "text-white"
                )}
              >
                {item.name}
              </h4>
            </Link>
          );
        })}
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className=" items-center gap-1.5 cursor-pointer hidden lg:flex">
            <img
              src="https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/avatars/91/914ba47874e675167658078508781e39b3984f5c_full.jpg"
              alt="avatar"
              className="w-[32px] h-[32px] p-1 rounded-full border-1 border-[#6366F1]"
            />
            <h4 className="text-[#131515] text-sm">{user?.name || "Vendor"}</h4>
            <ChevronDown className="size-4 text-[#868787]" />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="w-48 rounded-lg"
          // side={isMobile ? 'bottom' : 'right'}
          // align={isMobile ? 'end' : 'start'}
        >
          {/* <DropdownMenuItem>
            <Folder className='text-muted-foreground' />
            <span>Profile</span>
          </DropdownMenuItem> */}
          <DropdownMenuItem asChild>
            <Link to={SETTINGS} className="flex items-center gap-2">
              <SettingsSvgIcon className="text-muted-foreground" />
              <span>Profile/Settings</span>
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="text-red-500 group"
            onClick={clientLogout}
          >
            {/* <LogOut className='text-red-500' /> */}
            <LogoutSvgIcon fill="#fb2c36" />
            <span className="group-hover:text-red-500">Logout</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ToggleSidebar className="lg:hidden" />
    </section>
  );
}
